// ─── Public Status Page — the page frame ─────────────────────────────
//
// Header, the scrolling <main>, footer. It renders nothing of its own: the
// header and footer arrive as nodes from App.tsx, and the sections arrive as
// children. That keeps the page's information architecture in ONE file
// (status/App.tsx) instead of being split between a layout and a page.
//
// The <main> carries STATUS_MAIN_ID and `tabIndex={-1}` because it is the skip
// link's target. Without the negative tabindex, `href="#sp-main"` scrolls the
// viewport but leaves keyboard focus back on the skip link, so the next Tab
// returns to the header — the skip does nothing for the visitor it exists for.
//
// The width constraint lives on an INNER .sp-container rather than on <main>
// itself, so the header's bottom border and the footer's top border still run
// the full width of the viewport while their contents stay aligned with the
// column.

import { STATUS_MAIN_ID, type StatusShellProps } from '../types';

export function StatusShell({ header, footer, children }: StatusShellProps) {
  return (
    <div className="sp-shell">
      {header}
      <main id={STATUS_MAIN_ID} className="sp-main" tabIndex={-1}>
        <div className="sp-container sp-main-stack">{children}</div>
      </main>
      {footer}
    </div>
  );
}
